/**
 * Canonical schedule / API profile id → short label for UI (storage stays canonical).
 * Bidder ids like `assistant4webster` must never appear as the Profile column value.
 */
const SCHEDULE_PROFILE_LABELS = {
  assistant4timothy: "timothy",
  assistant4webster: "webster",
  assistant4milton: "milton",
  timothy: "timothy",
  webster: "webster",
  milton: "milton",
  "timothy pettit": "timothy",
  "webster kiliona": "webster",
  "milton caraballo": "milton",
  // Newer Jiracoders bidder ids → readable short labels
  assistant4randerson: "richard anderson",
  assistant4cache: "cache",
  assistant4shane: "shane",
  assistant4jwilliams: "justin williams",
  "richard anderson": "richard anderson",
  "cache kirschenman": "cache",
  "shane hallock": "shane",
  "justin willams": "justin williams",
  "justin williams": "justin williams",
  seth: "Seth Davis",
  "seth davis": "Seth Davis",
};

function foldKey(name) {
  return String(name || "")
    .trim()
    .replace(/^bidder_/i, "")
    .toLowerCase();
}

/**
 * Human-facing profile label for any UI surface.
 * Safe to call with null/undefined/arrays of names.
 */
export function scheduleProfileDisplay(canonicalName) {
  if (Array.isArray(canonicalName)) {
    return formatProfileList(canonicalName);
  }
  if (canonicalName == null || typeof canonicalName !== "string") return canonicalName || "—";
  const trimmed = canonicalName.trim();
  if (!trimmed) return "—";
  const folded = foldKey(trimmed);
  if (SCHEDULE_PROFILE_LABELS[folded]) return SCHEDULE_PROFILE_LABELS[folded];
  // assistant4foo / assistant12bar → foo / bar when we have no explicit label
  const stripped = folded.match(/^assistant\d+(.+)$/);
  if (stripped?.[1]) return stripped[1];
  return trimmed;
}

/** Join profile ids into a comma-separated display string. */
export function formatProfileList(names, { empty = "None" } = {}) {
  const list = (Array.isArray(names) ? names : [names])
    .map((n) => scheduleProfileDisplay(n))
    .filter((n) => n && n !== "—");
  return list.length ? list.join(", ") : empty;
}

/** Match server `normalizeScheduleProfileName` for client-side schedule builder state. */
export function normalizeScheduleProfileClient(name) {
  if (name == null || typeof name !== "string") return name;
  const t = name.trim();
  const lower = foldKey(t);
  const byLower = {
    timothy: "assistant4timothy",
    webster: "assistant4webster",
    milton: "assistant4milton",
    "timothy pettit": "assistant4timothy",
    "webster kiliona": "assistant4webster",
    "milton caraballo": "assistant4milton",
    assistant4timothy: "assistant4timothy",
    assistant4webster: "assistant4webster",
    assistant4milton: "assistant4milton",
    assistant4randerson: "Richard Anderson",
    "richard anderson": "Richard Anderson",
    assistant4cache: "Cache Kirschenman",
    cache: "Cache Kirschenman",
    "cache kirschenman": "Cache Kirschenman",
    assistant4shane: "Shane Hallock",
    shane: "Shane Hallock",
    "shane hallock": "Shane Hallock",
    assistant4jwilliams: "Justin Williams",
    "justin willams": "Justin Williams",
    "justin williams": "Justin Williams",
    seth: "Seth Davis",
    "seth davis": "Seth Davis",
  };
  if (byLower[lower]) return byLower[lower];
  const map = {
    Timothy: "assistant4timothy",
    Webster: "assistant4webster",
    Milton: "assistant4milton",
    "Ramiro Bucio": "Ramiro",
    "Justin Willams": "Justin Williams",
  };
  return map[t] || t;
}
